import React from "react";
import { motion } from "framer-motion";

const HomeTestimonials = ({ testimonials }) => (
  <section className="py-5 bg-white" id="testimonials">
    <div className="container text-center">
      <h2 className="fw-bold mb-3" style={{ color: "#0071BD" }}>
        {testimonials.title}
      </h2>
      <p className="text-muted mb-5">{testimonials.subtitle}</p>

      <div className="row g-4">
        {testimonials.cards.map((t, i) => (
          <motion.div
            key={t.id}
            className="col-md-4"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: i * 0.2 }}
          >
            <div className="p-4 rounded-4 shadow-sm h-100" style={{ borderTop: `4px solid #F17E00` }}>
              <img src={t.avatar} alt={t.name} width={70} height={70} className="rounded-circle mb-3" />
              <p className="text-secondary fst-italic">“{t.comment}”</p>
              <h6 className="mt-3 mb-0" style={{ color: "#0071BD" }}>{t.name}</h6>
              <small className="text-muted">{t.role}</small>
              <h6 className="fw-bold">{t.companyname}</h6>

            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default HomeTestimonials;
